'use client';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';

import {
  CardSmall,
  SubCategory,
  useCategoryPageData,
} from '@/entities/category';

import styles from './categoryPage.module.scss';

interface CatalogPageProps {
  slug: string;
  breadcrumbs?: ReactNode;
}

const CatalogPage: FC<CatalogPageProps> = (props) => {
  const { slug, breadcrumbs } = props;
  const { data } = useCategoryPageData({ slug });
  function renderCategoryItem(item: SubCategory, index: number) {
    return (
      <CardSmall
        key={index}
        category={data?.slug ?? ''}
        className={styles.catalog__card}
        item={item}
      />
    );
  }

  if (!data) {
    return null;
  }

  return (
    <main className={classNames(styles.catalog, 'page')}>
      <div className={classNames('container', styles.catalog__wrapper)}>
        <div className={styles.catalog__title_block}>
          <h1 className={styles.catalog__title}>{data.name}</h1>
        </div>
        <div className={styles.catalog__content}>
          {data.subcategory_list?.map(renderCategoryItem)}
        </div>
        {breadcrumbs}
      </div>
    </main>
  );
};

export default CatalogPage;
